<template>
  <div class="assessment">
    <div class="list-group">
      <!-- AI Analysis (Summary & Feedback) -->
      <AIAnalysis v-if="enableAI" :physician_id="physician_id" :hcp-data="hcpData" />

      <!-- Relationship Graph (Academic Cooperation) -->
      <div class="list-group-item" style="margin-top: 15px;">
        <section>
          <!-- Using the existing relationship component which handles its own data fetching via route query -->
          <relationship />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore';
import * as py from '@/api/Physicians';
import relationship from '../../hcp/components/relationship';
import AIAnalysis from '../../hcp/components/AIAnalysis.vue';
import sortDynamicMixins from '@/mixins/sortDynamicMixins';
import { isEnableAI } from '@/utils/index';

export default {
  name: 'Persona',
  components: {
    AIAnalysis,
    relationship
  },
  mixins: [sortDynamicMixins],
  props: {
    showProduct: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      physician_id: this.$route.query.physician_id,
      hcpData: {},
      radarLoading: false,
      hospitalMap: {},
      hospitalArr: [],
      schedulesList: [],
    };
  },
  computed: {
    enableAI() {
      return isEnableAI();
    },
  },
  mounted() {
    this.getHcpScore();
  },
  methods: {
    getHcpScore() {
      this.hcpData = {};
      this.radarLoading = true;
      py.getPhysiciansScore(this.$route.query.physician_id)
        .then((res) => {
          if (res.length) {
            this.hcpData = res[0];

            // Basic data processing if needed for AIAnalysis or other components
            if (this.hcpData.physician__physician_schedules.length) {
              this.hcpData.physician__physician_schedules.forEach((sc) => {
                sc.hospital = sc.institution_name.split('\n')[0];
              });
              this.hospitalMap = _.groupBy(
                this.hcpData.physician__physician_schedules,
                'hospital',
              );
              for (let mp in this.hospitalMap) {
                this.hospitalArr.push(mp);
              }
              this.schedulesList = this.hcpData.physician__physician_schedules;
            }
          }
          this.radarLoading = false;
        })
        .catch((e) => {
          this.radarLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.assessment {
  padding-bottom: 20px;
}
.list-group-item {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
  margin-bottom: 10px;
}
</style>
